import { Injectable, ComponentFactoryResolver, ComponentFactory } from '@angular/core';

import { ProviderPayratesHistoryComponent } from './provider-payrates-history.component';

@Injectable({
    providedIn: 'root'
})
export class ProviderPayratesHistoryProvider {
    constructor(private resolver: ComponentFactoryResolver) {
        this.componentFactory = this.resolver.resolveComponentFactory(ProviderPayratesHistoryComponent);
    }
    componentFactory: ComponentFactory<unknown>;
}